export const tr = {
    'block-description':
        'Bu şekilde reklamınız kullanıcılar tarafından görülür. Ne kadar çok alan doldurursanız o kadar çok gösterim alanına sahip olabilirsiniz.',
    'block-title': 'Reklam önizleme',
    'go-to-link-btn': 'Bağlantıya git',
    'play-btn': 'Video izle',
    'play-btn-audio': 'Ses kaydını oynat',
    'play-btn-common': 'Oynat',
    'play-btn-video': 'Video izle'
};
